export async function serviceRequest(endPoint: string, ...requestParams) {
    const [{ method = "POST", headers = {}, body = {} }] = requestParams;
    const request: RequestInit = {
        method,
        credentials: "same-origin",
        headers: {
            ...{
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            ...headers
        },
        body: JSON.stringify(body)
    };

    if (method.toUpperCase() === "GET") delete request.body;

    try {
        return await fetch(endPoint, request);
    } catch (error) {
        console.log("serviceRequest error", error);
    }
}

export async function handleResponse(response: Response) {
    // Get the response content type so we can decide how to handle the response
    const contentType = response.headers.get("content-type") || "";

    // Set a default response type
    let responseType = "json";

    // Change response type for other content types
    if (contentType.includes("text")) responseType = "text";
    if (contentType.includes("pdf")) responseType = "blob";
    if (contentType.includes("zip")) responseType = "blob";
    if (contentType === "") responseType = null;

    // Await the response according to response type, e.g. response.json(), response.text()
    const responseBody = responseType
        ? await response[responseType]()
        : response;

    // Throw an exception for responses in the 400 range
    if (response.status >= 400 && response.status < 500) {
        throw {
            status: response.status,
            error: responseBody
        };
    }

    // Throw an error for responses not in the 200 range
    if (!response.ok) throw Error(response.statusText);

    // If everything is ok return the response body
    return responseBody;
}

export const asyncApiCall = async (endPoint: string, request: object = {}) =>
    await handleResponse(await serviceRequest(endPoint, request));


// WEBPACK FOOTER //
// ./src/utils/services.ts